export default __webpack_public_path__ + "static/microscope-d83a00382ec2473521fb6a67126a10b0.webp";